// ============================================================
//  translations.js — كل نصوص التطبيق بالعربي والعبري
// ============================================================

export const translations = {

  // ── عام ──────────────────────────────────────────────────
  appName:       { ar: 'الشلالة',                    he: 'אלשללאלה' },
  appSubtitle:   { ar: 'نظام إدارة المياه الزراعية', he: 'מערכת ניהול מים חקלאיים' },
  logout:        { ar: 'خروج',                       he: 'התנתק' },
  save:          { ar: 'حفظ',                        he: 'שמור' },
  cancel:        { ar: 'إلغاء',                      he: 'ביטול' },
  edit:          { ar: 'تعديل',                      he: 'עריכה' },
  delete:        { ar: 'حذف',                        he: 'מחיקה' },
  add:           { ar: 'إضافة',                      he: 'הוסף' },
  search:        { ar: 'بحث...',                     he: 'חיפוש...' },
  loading:       { ar: 'جاري التحميل...',            he: 'טוען...' },
  saving:        { ar: 'جاري الحفظ...',              he: 'שומר...' },
  noData:        { ar: 'لا توجد بيانات',             he: 'אין נתונים' },
  confirm:       { ar: 'تأكيد',                      he: 'אישור' },
  all:           { ar: 'الكل',                       he: 'הכל' },
  year:          { ar: 'السنة',                      he: 'שנה' },
  optional:      { ar: 'اختياري',                    he: 'אופציונלי' },
  required:      { ar: 'مطلوب',                      he: 'חובה' },
  notes:         { ar: 'ملاحظة',                     he: 'הערה' },
  name:          { ar: 'الاسم',                      he: 'שם' },
  total:         { ar: 'المجموع',                    he: 'סה"כ' },
  print:         { ar: 'طباعة',                      he: 'הדפסה' },
  cups:          { ar: 'كوب',                        he: 'קוב' },
  amount:        { ar: 'المبلغ',                     he: 'סכום' },
  price:         { ar: 'السعر',                      he: 'מחיר' },
  pricePerCup:   { ar: 'السعر/كوب',                  he: 'מחיר/קוב' },
  period:        { ar: 'الفترة',                     he: 'תקופה' },
  from:          { ar: 'من',                         he: 'מ' },
  to:            { ar: 'إلى',                        he: 'עד' },
  area:          { ar: 'المساحة',                    he: 'שטח' },
  dunam:         { ar: 'دونم',                       he: 'דונם' },
  phone:         { ar: 'الهاتف',                     he: 'טלפון' },
  idNumber:      { ar: 'رقم الهوية',                 he: 'מספר ת"ז' },
  personalCode:  { ar: 'الكود الشخصي',               he: 'קוד אישי' },
  region:        { ar: 'المنطقة',                    he: 'אזור' },
  allRegions:    { ar: 'جميع المناطق',               he: 'כל האזורים' },
  allFarmers:    { ar: 'جميع المزارعين',             he: 'כל החקלאים' },
  allYears:      { ar: 'جميع السنوات',               he: 'כל השנים' },
  date:          { ar: 'التاريخ',                    he: 'תאריך' },

  // ── صفحة الدخول ──────────────────────────────────────────
  login:           { ar: 'دخول',                    he: 'כניסה' },
  farmerLogin:     { ar: 'دخول المزارع',            he: 'כניסת חקלאי' },
  adminLogin:      { ar: 'الإدارة',                 he: 'ניהול' },
  adminPassword:   { ar: 'كلمة مرور الإدارة',      he: 'סיסמת מנהל' },
  enterIdNumber:   { ar: 'أدخل رقم الهوية',        he: 'הזן מספר ת"ז' },
  enterCode:       { ar: 'أدخل الكود',              he: 'הזן קוד' },
  enterPassword:   { ar: 'أدخل كلمة المرور',       he: 'הזן סיסמה' },
  loginBtn:        { ar: 'دخول ←',                  he: 'כניסה ←' },
  adminLoginBtn:   { ar: 'دخول الإدارة ←',          he: 'כניסת מנהל ←' },
  failedToFetch:   { ar: 'لا يمكن الاتصال بالخادم', he: 'לא ניתן להתחבר לשרת' },
  wrongCredentials:{ ar: 'بيانات الدخول غير صحيحة', he: 'פרטי כניסה שגויים' },
  codeFormat:      { ar: 'الكود يجب أن يكون 4 أرقام', he: 'הקוד חייב להיות 4 ספרות' },
  fillAllFields:   { ar: 'يرجى ملء جميع الحقول',   he: 'נא למלא את כל השדות' },

  // ── لوحة المزارع ─────────────────────────────────────────
  welcome:         { ar: 'مرحباً',                  he: 'שלום' },
  overview:        { ar: 'نظرة عامة',               he: 'סקירה כללית' },
  years:           { ar: 'السنوات',                 he: 'שנים' },
  lands:           { ar: 'الأراضي',                 he: 'קרקעות' },
  farmNotes:       { ar: 'المفكرة الزراعية',        he: 'יומן חקלאי' },
  numLands:        { ar: 'عدد الأراضي',             he: 'מספר קרקעות' },
  dataYears:       { ar: 'سنوات البيانات',          he: 'שנות נתונים' },
  totalCups:       { ar: 'إجمالي الأكواب',          he: 'סה"כ קובים' },
  totalAmount:     { ar: 'إجمالي المبلغ',           he: 'סה"כ סכום' },
  consumptionChart:{ ar: 'استهلاك المياه بالأكواب',  he: 'צריכת מים בקובים' },
  amountChart:     { ar: 'المبلغ بالسنوات',          he: 'סכום לפי שנים' },
  landDistribution:{ ar: 'توزيع الاستهلاك بين الأراضي', he: 'חלוקת צריכה בין קרקעות' },
  landSummary:     { ar: 'ملخص الأراضي',            he: 'סיכום קרקעות' },
  noReadings:      { ar: 'لا توجد قراءات مسجلة',   he: 'אין קריאות רשומות' },
  yearDetails:     { ar: 'تفاصيل سنة',              he: 'פרטי שנה' },
  searchLand:      { ar: 'ابحث باسم الأرض...',      he: 'חפש לפי שם קרקע...' },
  noLands:         { ar: 'لا توجد أراضٍ مطابقة',   he: 'לא נמצאו קרקעות' },
  totalConsumption:{ ar: 'كوب إجمالي',              he: 'קובים סה"כ' },
  totalBill:       { ar: 'مبلغ إجمالي',             he: 'סכום סה"כ' },
  noYearData:      { ar: 'لا توجد بيانات',          he: 'אין נתונים' },

  // ── المفكرة الزراعية ──────────────────────────────────────
  farmNotesTitle:  { ar: 'المفكرة الزراعية',        he: 'יומן חקלאי' },
  farmNotesDesc:   { ar: 'سجل عملياتك وموادك الزراعية', he: 'רשום פעולות וחומרים חקלאיים' },
  addRecord:       { ar: '+ تسجيل جديد',            he: '+ רשומה חדשה' },
  operation:       { ar: 'نوع العملية',             he: 'סוג הפעולה' },
  description:     { ar: 'الوصف / المادة',          he: 'תיאור / חומר' },
  quantity:        { ar: 'الكمية',                  he: 'כמות' },
  unit:            { ar: 'الوحدة',                  he: 'יחידה' },
  saveToArchive:   { ar: '💾 حفظ في الأرشيف',       he: '💾 שמור בארכיון' },
  allLands:        { ar: 'جميع الأراضي',            he: 'כל הקרקעות' },
  noNotes:         { ar: 'لا توجد تسجيلات بعد',     he: 'אין רשומות עדיין' },
  spray:           { ar: 'رش',                      he: 'ריסוס' },
  fertilizer:      { ar: 'سماد',                    he: 'דשן' },
  plow:            { ar: 'حرث',                     he: 'חרישה' },
  harvest:         { ar: 'حصاد',                    he: 'קציר' },
  planting:        { ar: 'زراعة',                   he: 'נטיעה' },
  pesticide:       { ar: 'مبيد حشري',               he: 'קוטל חרקים' },
  manualIrrigation:{ ar: 'ري يدوي',                 he: 'השקיה ידנית' },
  maintenance:     { ar: 'صيانة',                   he: 'תחזוקה' },
  other:           { ar: 'أخرى',                    he: 'אחר' },
  liter:           { ar: 'لتر',                     he: 'ליטר' },
  kg:              { ar: 'كجم',                     he: 'ק"ג' },
  ton:             { ar: 'طن',                      he: 'טון' },
  bag:             { ar: 'كيس',                     he: 'שקית' },
  box:             { ar: 'علبة',                    he: 'קופסה' },
  unitWord:        { ar: 'وحدة',                    he: 'יחידה' },
  chooseLand:      { ar: 'الرجاء اختيار الأرض',     he: 'נא לבחור קרקע' },
  chooseDesc:      { ar: 'الرجاء إدخال الوصف',      he: 'נא להזין תיאור' },
  deleteNote:      { ar: 'هل تريد حذف هذه الملاحظة؟', he: 'האם למחוק רשומה זו?' },

  // ── لوحة الإدارة ─────────────────────────────────────────
  adminPanel:      { ar: 'لوحة الإدارة',            he: 'לוח ניהול' },
  farmers:         { ar: 'المزارعون',               he: 'חקלאים' },
  regionsTab:      { ar: 'المناطق الزراعية',        he: 'אזורים חקלאיים' },
  readingsTab:     { ar: 'القراءات والأراضي',       he: 'קריאות וקרקעות' },
  pricesTab:       { ar: 'الأسعار',                 he: 'מחירים' },
  reportsTab:      { ar: 'التقارير',                he: 'דוחות' },
  galleryTab:      { ar: 'المعرض والوسائط',         he: 'גלריה ומדיה' },
  settingsTab:     { ar: 'الإعدادات',               he: 'הגדרות' },

  // ── المزارعون ─────────────────────────────────────────────
  addFarmer:       { ar: '+ إضافة مزارع',           he: '+ הוסף חקלאי' },
  editFarmer:      { ar: '✏️ تعديل مزارع',          he: '✏️ עריכת חקלאי' },
  newFarmer:       { ar: '+ مزارع جديد',            he: '+ חקלאי חדש' },
  nameAr:          { ar: 'الاسم (عربي)',             he: 'שם (ערבית)' },
  nameHe:          { ar: 'الاسم (عبري)',             he: 'שם (עברית)' },
  codeKeep:        { ar: 'فارغ = بدون تغيير',       he: 'ריק = ללא שינוי' },
  deleteFarmer:    { ar: 'حذف المزارع',             he: 'מחיקת חקלאי' },
  deleteFarmerConfirm: { ar: 'سيتم حذف جميع أراضيه وقراءاته', he: 'כל הקרקעות והקריאות יימחקו' },
  numFarmers:      { ar: 'مزارع',                   he: 'חקלאים' },
  idDuplicate:     { ar: 'رقم الهوية موجود مسبقاً', he: 'מספר ת"ז כבר קיים' },

  // ── المناطق ───────────────────────────────────────────────
  addRegion:       { ar: '+ إضافة منطقة',           he: '+ הוסף אזור' },
  newRegion:       { ar: '+ منطقة جديدة',           he: '+ אזור חדש' },
  editRegion:      { ar: '✏️ تعديل منطقة',          he: '✏️ עריכת אזור' },
  regionName:      { ar: 'اسم المنطقة',             he: 'שם האזור' },
  regionRequired:  { ar: 'اسم المنطقة مطلوب',       he: 'שם האזור חובה' },
  deleteRegionConfirm: { ar: 'سيتم إزالتها من جميع الأراضي', he: 'יוסר מכל הקרקעות' },
  noRegions:       { ar: 'لا توجد مناطق بعد',       he: 'אין אזורים עדיין' },
  regionsDesc:     { ar: 'أضف وعدّل المناطق الزراعية', he: 'הוסף וערוך אזורים חקלאיים' },

  // ── القراءات ──────────────────────────────────────────────
  addReading:      { ar: '+ إضافة قراءة',           he: '+ הוסף קריאה' },
  editReading:     { ar: '✏️ تعديل قراءة',          he: '✏️ עריכת קריאה' },
  newLand:         { ar: '+ أرض جديدة',             he: '+ קרקע חדשה' },
  chooseFarmer:    { ar: 'اختر المزارع',            he: 'בחר חקלאי' },
  chooseLandOpt:   { ar: 'اختر الأرض',              he: 'בחר קרקע' },
  chooseRegion:    { ar: 'اختر المنطقة',            he: 'בחר אזור' },
  manageLands:     { ar: 'إدارة الأراضي',           he: 'ניהול קרקעות' },
  readingFirst:    { ar: 'قراءة أولى',              he: 'קריאה ראשונה' },
  readingNum:      { ar: 'قراءة',                   he: 'קריאה' },
  addReadingField: { ar: '+ قراءة إضافية',          he: '+ קריאה נוספת' },
  diff:            { ar: 'الفرق',                   he: 'הפרש' },
  landArea:        { ar: 'المساحة (دونم)',           he: 'שטח (דונם)' },
  landNameAr:      { ar: 'اسم الأرض (عربي)',        he: 'שם קרקע (ערבית)' },
  landNameHe:      { ar: 'اسم الأرض (عبري)',        he: 'שם קרקע (עברית)' },
  numReadings:     { ar: 'قراءة',                   he: 'קריאות' },
  deleteReading:   { ar: 'حذف هذه القراءة؟',        he: 'למחוק קריאה זו?' },
  deleteLand:      { ar: 'حذف الأرض',              he: 'מחיקת קרקע' },
  readingsLabel:   { ar: 'القراءات',                he: 'קריאות' },
  selectedRegion:  { ar: 'المنطقة',                 he: 'אזור' },

  // ── الأسعار ───────────────────────────────────────────────
  globalPrice:     { ar: 'السعر العام الافتراضي',   he: 'מחיר כללי ברירת מחדל' },
  globalPriceDesc: { ar: 'يُطبَّق على القراءات التي ليس لها سعر خاص', he: 'חל על קריאות ללא מחיר מיוחד' },
  currentPrice:    { ar: 'السعر الحالي',            he: 'מחיר נוכחי' },
  yearlyPrices:    { ar: 'أسعار خاصة بالسنوات',    he: 'מחירים לפי שנה' },
  landPrices:      { ar: 'أسعار خاصة بالأراضي',    he: 'מחירים לפי קרקע' },
  defaultPrice:    { ar: 'السعر الافتراضي',         he: 'מחיר ברירת מחדל' },
  reading1Price:   { ar: 'سعر القراءة 1',           he: 'מחיר קריאה 1' },
  reading2Price:   { ar: 'سعر القراءة 2',           he: 'מחיר קריאה 2' },
  reading3Price:   { ar: 'سعر القراءة 3',           he: 'מחיר קריאה 3' },
  addYear:         { ar: 'إضافة سنة',              he: 'הוסף שנה' },
  addLandPrice:    { ar: 'إضافة سعر لأرض',         he: 'הוסף מחיר לקרקע' },
  noYearPrices:    { ar: 'لا توجد أسعار خاصة بالسنوات', he: 'אין מחירים לפי שנה' },
  noLandPrices:    { ar: 'لا توجد أسعار خاصة بالأراضي', he: 'אין מחירים לפי קרקע' },
  priceHierarchy:  { ar: 'أولوية الأسعار (الأعلى أولاً)', he: 'עדיפות מחירים (גבוה ראשון)' },

  // ── التقارير ──────────────────────────────────────────────
  summaryReport:   { ar: 'ملخص',                   he: 'סיכום' },
  detailedReport:  { ar: 'تفصيلي',                 he: 'מפורט' },
  farmerComparison:{ ar: 'مقارنة المزارعين',        he: 'השוואת חקלאים' },
  farmersSummary:  { ar: 'ملخص المزارعين',          he: 'סיכום חקלאים' },

  // ── المعرض ────────────────────────────────────────────────
  gallery:         { ar: 'معرض الصور',             he: 'גלריית תמונות' },
  video:           { ar: 'فيديو',                  he: 'וידאו' },
  uploadImages:    { ar: 'اختر صوراً للرفع',        he: 'בחר תמונות להעלאה' },
  uploadTypes:     { ar: 'PNG, JPG, WEBP — عدة صور', he: 'PNG, JPG, WEBP — מספר תמונות' },
  caption:         { ar: 'تعليق',                  he: 'כיתוב' },
  captionPlaceholder: { ar: 'تعليق للصور الجديدة', he: 'כיתוב לתמונות חדשות' },
  youtubeLink:     { ar: 'رابط يوتيوب',            he: 'קישור יוטיוב' },
  videoTitle:      { ar: 'عنوان الفيديو',          he: 'כותרת הוידאו' },
  deleteVideo:     { ar: '🗑️ حذف الفيديو',         he: '🗑️ מחק וידאו' },
  noGallery:       { ar: 'لا توجد صور في المعرض',  he: 'אין תמונות בגלריה' },

  // ── الإعدادات ─────────────────────────────────────────────
  announcement:    { ar: 'إعلان صفحة الدخول',     he: 'הודעת דף כניסה' },
  announcementDesc:{ ar: 'يظهر بارزاً في أعلى صفحة تسجيل الدخول', he: 'מוצג בולט בראש דף הכניסה' },
  announcementText:{ ar: 'نص الإعلان',             he: 'טקסט ההודעה' },
  announcementPlaceholder: { ar: 'مثال: تم إدخال قراءات الفصل الثاني', he: 'דוגמה: קריאות הרבעון השני הוזנו' },
  saveAnnouncement:{ ar: '💾 حفظ الإعلان',         he: '💾 שמור הודעה' },
  deleteAnnouncement: { ar: '🗑️ حذف الإعلان',     he: '🗑️ מחק הודעה' },
  changePassword:  { ar: 'كلمة مرور الإدارة',     he: 'סיסמת מנהל' },
  changePassDesc:  { ar: 'غيّر كلمة مرور الدخول للوحة الإدارة', he: 'שנה סיסמת כניסה ללוח ניהול' },
  newPassword:     { ar: 'كلمة المرور الجديدة',   he: 'סיסמה חדשה' },
  confirmPassword: { ar: 'تأكيد كلمة المرور',     he: 'אישור סיסמה' },
  changeBtn:       { ar: '🔐 تغيير',               he: '🔐 שנה' },
  passMin:         { ar: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل', he: 'הסיסמה חייבת להיות לפחות 6 תווים' },
  passMismatch:    { ar: 'كلمتا المرور غير متطابقتين', he: 'הסיסמאות אינן תואמות' },
};

// ── Helper function ──────────────────────────────────────────
export const t = (key, lang) => {
  if (!translations[key]) return key;
  return translations[key][lang] || translations[key]['ar'] || key;
};
